import { combineReducers } from 'redux';
import authReducer from './auth/auth.reducer';
import { AuthState } from './auth/auth.types';

import apiStatusReducer from './apiStatus/apiStatus.reducer'
import { ApiStatusState } from './apiStatus/apiStatus.types';
import { apiFeaturedReducer } from './mindsets/featured.reducer';
import { commentReducer } from './comment/comment.reducer';

import globalUIReducer from './globalUI/globalUI.reducer';
import { GlobalUIState } from './globalUI/globalUI.types';
import { FeaturedState } from './mindsets/featured.types';
import { CommentState } from './comment/comment.type';

export interface ApplicationState {
  auth: AuthState;
  apiStatus: ApiStatusState;
  globalUI: GlobalUIState;
  featured: FeaturedState;
  comment: CommentState;
}

const rootReducer = combineReducers({
  auth: authReducer,
  featured: apiFeaturedReducer,
  apiStatus: apiStatusReducer,
  globalUI: globalUIReducer,
  comment: commentReducer,
})

export default rootReducer;